import CacheHealth from './interfaces/CacheHealth';
import CacheInstallationState from './interfaces/CacheInstallationState';
import ClientAction from './interfaces/ClientAction';
import ClientMessage from './interfaces/ClientMessage';
import ServiceWorkerMessage from './interfaces/ServiceWorkerMessage';
import ServiceWorkerMessageType from './interfaces/ServiceWorkerMessageType';
import cacheProgressEventDispatcher from './cacheProgressEventDispatcher';
import serviceWorkerErrorEvent from './serviceWorkerErrorEvent';
import { getConsecutiveErrorCount } from './consecutiveErrorCount';
import { isFeatureEnabled } from 'owa-feature-flags';
import getRootVdirName from 'owa-url/lib/getRootVdirName';
import getIndexedPath from 'owa-url/lib/getIndexedPath';
import getQueryStringParameters from './utils/getQueryStringParameters';

const MAX_CONSECUTIVE_ERROR: number = 15;

let state: CacheInstallationState = null;
let windowObj: Window = null;

export function resetGlobals(): void {
    state = null;
    windowObj = null;
}

export function tryInitializeServiceWorkerCacheInstaller(
    installationState: CacheInstallationState,
    windowObject: Window
): void {
    if (!state) {
        state = installationState;
        state.serviceWorkerContainer.onmessage = serviceWorkerMessageEvent;
        if (getConsecutiveErrorCount(window, state) > MAX_CONSECUTIVE_ERROR) {
            state.cacheHealth = CacheHealth.TooManyInstallError;
        }
    }

    windowObj = windowObject;
}

export function installServiceWorkerCache(): void {
    const rootUrl = getIndexedPath('/' + getRootVdirName()) + '/';
    let manifestUrl: string = `${rootUrl}${
        state.appName
    }cache.manifest?${getQueryStringParameters(window, ['manifestVersion=2'])}`;
    let action: ClientAction = ClientAction.Install;

    // If cache health is not normal then first uninstall it
    if (state.cacheHealth > CacheHealth.Normal) {
        action = ClientAction.UnInstall;
    }

    let clientMessage: ClientMessage = {
        source: state.appName,
        action: action,
        bootResourcesOnly: true,
        language: state.userLanguage,
        darkMode: state.darkMode !== undefined ? state.darkMode : false,
        manifestUrl: manifestUrl,
        proxyFetchAlways: isFeatureEnabled('fwk-sw-proxyFetchAlways'),
        rootUrl,
    };
    state.serviceWorkerRegistration.active.postMessage(clientMessage);
}

export function serviceWorkerMessageEvent(messageEvent: MessageEvent): void {
    if (messageEvent.data) {
        let message: ServiceWorkerMessage = messageEvent.data;
        if (message.messageType == ServiceWorkerMessageType.CacheProgress) {
            cacheProgressEventDispatcher(windowObj, state, message);
        } else if (message.messageType == ServiceWorkerMessageType.Error) {
            serviceWorkerErrorEvent(message);
        }
    }
}
